__turbopack_context__.v({
  "video_container": "styles-module-scss-module__Uw1cuW__video_container",
  "video_invalid": "styles-module-scss-module__Uw1cuW__video_invalid",
  "video_player": "styles-module-scss-module__Uw1cuW__video_player",
});
